export { default } from '@framework/tenant/config/allocate';
